import ClearIcon from '@material-ui/icons/Clear'
import {useBagContext} from 'modules/reports/contexts/bag'
import useCore from 'modules/reports/hooks/core'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import ReportsTableOverlayButton from './Button'
import useStyles from './ReportsTableOverlay.styles'

type Props = {
  children: React.ReactNode
  'data-testid': string
}

function ReportsTableOverlay(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'TableOverlay')
  const bagContext = useBagContext()
  const propsP = usePrefix(props['data-testid'])

  if (!bagContext.items.length) return null

  return (
    <div className={classes.root} data-testid={propsP()}>
      <div className={classes.countContainer}>
        <span className={classes.count} data-testid={propsP('count')}>
          {bagContext.items.length}
        </span>
        <span className={classes.label}>{pt('selected')}</span>
      </div>

      {props.children}

      <ReportsTableOverlayButton
        icon={<ClearIcon />}
        label={pt('cancel')}
        data-testid={p('cancel')}
        onClick={bagContext.clear}
      />
    </div>
  )
}

export default ReportsTableOverlay
